import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { IFileSystemService } from './interface';

@Injectable({
    providedIn: 'root',
})
export class FileSystemService implements IFileSystemService {
    private defaultExtension = '.xlsx';

    public exportAsExcelFile(fileName: string, json: any[]): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
            dateNF: 'DD/MM/YY',
            cellDates: true,
        });
        const workbook: XLSX.WorkBook = {
            Sheets: { data: worksheet },
            SheetNames: ['data'],
        };

        XLSX.writeFile(workbook, `${fileName}${this.defaultExtension}`, {
            cellDates: true,
        });
    }
}
